import loadable from '@/utils/loadable';
import LoadingIndicator from '@/utils/LoadingIndicator';

export default loadable(() => import('./UserManagement'), {
  fallback: <LoadingIndicator />,
});
